"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSentenceEnvs = void 0;
const container_1 = require("../node/container");
const common_1 = require("./common");
const sentenceEnv_1 = require("../node/container/sentenceEnv");
const std = __importStar(require("../law/std"));
const num_1 = require("../law/num");
const getSentenceEnvs = (el) => {
    const sentenceEnvs = [];
    const sentenceEnvByEL = new Map();
    const containers = new Map();
    const containersByEL = new Map();
    let rootContainer = null;
    const lawType = el.attr.LawType ?? "";
    const dummyRootContainer = new container_1.Container({
        containerID: "container-dummy-root",
        type: container_1.ContainerType.ROOT,
        el,
        name: null,
        num: null,
        allSentenceEnvs: sentenceEnvs,
    });
    const extract = (el, prevContainer, prevParentELs) => {
        if ((0, common_1.isIgnoreAnalysis)(el))
            return;
        if ((0, sentenceEnv_1.isSentenceLike)(el) && !container_1.containerTags.includes(el.tag)) {
            const container = prevContainer ?? rootContainer ?? dummyRootContainer;
            if (!rootContainer)
                rootContainer = container;
            const sentenceEnv = new sentenceEnv_1.SentenceEnv({
                index: sentenceEnvs.length,
                elToBeModified: el,
                lawType,
                parentELs: [...prevParentELs],
                container,
            });
            sentenceEnvs.push(sentenceEnv);
            sentenceEnvByEL.set(el, sentenceEnv);
            return;
        }
        else {
            const parentELs = [...prevParentELs, el];
            let container = prevContainer;
            if (container_1.containerTags.includes(el.tag)) {
                const name = (el.children.find(c => (std.isArticleTitle(c)
                    || std.isParagraphItemTitle(c)
                    || std.isArticleGroupTitle(c)
                    || std.isAppdxItemTitle(c)
                    || std.isSupplProvisionLabel(c)
                    || std.isSupplProvisionAppdxItemTitle(c)))?.text()
                    ?? null);
                const num = ((name && (0, num_1.parseNamedNum)(name))
                    || ((std.isParagraph(el) && "1") || null));
                const containerID = prevContainer ? `${prevContainer.containerID}-${el.tag}[${prevContainer.children.filter(c => c.el.tag === el.tag).length + 1}]${num ? "[num=" + num + "]" : ""}` : `container-${el.tag}`;
                container = new container_1.Container({
                    el,
                    name,
                    num,
                    containerID,
                    allSentenceEnvs: sentenceEnvs,
                });
                if (prevContainer)
                    prevContainer.addChild(container);
                containers.set(container.containerID, container);
                containersByEL.set(el, container);
                if (!rootContainer)
                    rootContainer = container;
                if ((0, sentenceEnv_1.isSentenceLike)(el)) {
                    const sentenceEnv = new sentenceEnv_1.SentenceEnv({
                        index: sentenceEnvs.length,
                        elToBeModified: el,
                        lawType,
                        parentELs: [...prevParentELs],
                        container,
                    });
                    sentenceEnvs.push(sentenceEnv);
                    sentenceEnvByEL.set(el, sentenceEnv);
                }
            }
            const startSentenceIndex = sentenceEnvs.length;
            for (const child of el.children) {
                if (typeof child === "string")
                    continue;
                extract(child, container, parentELs);
            }
            const endSpanIndex = sentenceEnvs.length; // half open
            if (container)
                container.sentenceRange = [startSentenceIndex, endSpanIndex];
        }
    };
    extract(el, null, []);
    dummyRootContainer.sentenceRange = [0, sentenceEnvs.length];
    if (!rootContainer)
        throw new Error();
    return { sentenceEnvs, sentenceEnvByEL, containers, containersByEL, rootContainer };
};
exports.getSentenceEnvs = getSentenceEnvs;
exports.default = exports.getSentenceEnvs;
//# sourceMappingURL=getSentenceEnvs.js.map